module.exports = __webpack_public_path__ + "img/recover-credentials-example-mobile.57ce367c.png";